import './jump-dialog-demo.css'

/**
 * Looping demo illustration for the Jump confirm dialog (#266): the layered
 * SVG export of the "demo" layer of Figma node 23125:130934 in file
 * Lqc5IT4YdGMUgh0JWgO8zK (Focus Pass Events), inlined so its pieces can be
 * driven by the pure-CSS keyframes in jump-dialog-demo.css. Motion values
 * come from the same node's Figma motion timeline (see the CSS header);
 * under prefers-reduced-motion the scene renders as the static illustration.
 *
 * Structural changes vs the raw export: the location pin gets two nested
 * <g> wrappers (drop + scale) so its two transform tracks compose, and the
 * chevrons get a shared slide wrapper.
 */
export function JumpDialogDemo(props: { className?: string }) {
  return (
    <svg
      className={props.className}
      viewBox="0 0 252 138"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23125_130830)">
        <path
          className="jump-demo-trail"
          filter="url(#filter0_d_23125_130830)"
          d="M164 91.1295C149.994 75.0759 131.373 66.6781 109.5 65.9999C85.061 65.2422 52.4519 76.3601 23.5 99.6295"
          pathLength={1}
          stroke="url(#paint0_radial_23125_130830)"
          strokeWidth={28}
          strokeLinecap="round"
          strokeDasharray="1 1"
        />
        <ellipse
          className="jump-demo-highlight"
          opacity={0.3}
          cx={164.5}
          cy={115.5}
          rx={44.5}
          ry={16.5}
          fill="#A5A5A5"
          fillOpacity={0.5}
        />
        <ellipse
          className="jump-demo-shadow"
          cx={165}
          cy={114.5}
          rx={10}
          ry={3.5}
          fill="black"
          fillOpacity={0.14}
        />
        <g className="jump-demo-location-drop">
          <g className="jump-demo-location-scale">
            <g filter="url(#filter1_di_23125_130830)">
              <path
                d="M191 74.368C191 85.9367 174.276 105.831 167.533 113.383C166.039 115.056 163.488 115.056 161.994 113.383C155.251 105.831 138.527 85.9367 138.527 74.368C138.527 59.8779 150.273 48.1313 164.763 48.1313C179.253 48.1313 191 59.8779 191 74.368Z"
                fill="white"
              />
            </g>
            <g filter="url(#filter2_i_23125_130830)">
              <circle cx={164.763} cy={75.0003} r={14.2247} fill="#333333" />
            </g>
          </g>
        </g>
        <g className="jump-demo-speedup">
          <g filter="url(#filter3_d_23125_130830)">
            <path
              className="jump-demo-chevron-right"
              opacity={0.5}
              d="M86.6338 29.9925C84.8503 27.6064 85.2099 24.1232 87.4383 22.2136C89.6677 20.3047 92.9219 20.6896 94.7061 23.0747L108.842 41.9877C110.169 43.7628 110.169 46.1994 108.842 47.9745L94.7061 66.8875C92.9219 69.2727 89.6677 69.6576 87.4383 67.7487C85.2099 65.839 84.8503 62.3558 86.6338 59.9697L97.3893 45.5798C97.6547 45.2248 97.6547 44.7375 97.3893 44.3824L86.6338 29.9925Z"
              fill="#FFD96D"
            />
            <path
              className="jump-demo-chevron-middle"
              opacity={0.5}
              d="M65.6338 29.9925C63.8503 27.6064 64.2099 24.1232 66.4383 22.2136C68.6677 20.3047 71.9219 20.6896 73.7061 23.0747L87.8424 41.9877C89.1691 43.7628 89.1691 46.1994 87.8424 47.9745L73.7061 66.8875C71.9219 69.2727 68.6677 69.6576 66.4383 67.7487C64.2099 65.839 63.8503 62.3558 65.6338 59.9697L76.3893 45.5798C76.6547 45.2248 76.6547 44.7375 76.3893 44.3824L65.6338 29.9925Z"
              fill="#FFD96D"
            />
            <path
              className="jump-demo-chevron-left"
              opacity={0.5}
              d="M43.6338 29.9925C41.8503 27.6064 42.2099 24.1232 44.4383 22.2136C46.6677 20.3047 49.9219 20.6896 51.7061 23.0747L65.8424 41.9877C67.1691 43.7628 67.1691 46.1994 65.8424 47.9745L51.7061 66.8875C49.9219 69.2727 46.6677 69.6576 44.4383 67.7487C42.2099 65.839 41.8503 62.3558 43.6338 59.9697L54.3893 45.5798C54.6547 45.2248 54.6547 44.7375 54.3893 44.3824L43.6338 29.9925Z"
              fill="#FFD96D"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_23125_130830"
          x="6.89951"
          y="29.3636"
          width="199.701"
          height="92.8663"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="13" dy="-7" />
          <feGaussianBlur stdDeviation="7.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.437988 0 0 0 0 1 0 0 0 0 0.718994 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_23125_130830"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_23125_130830"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_di_23125_130830"
          x="108.945"
          y="16.5497"
          width="111.637"
          height="125.669"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.68169"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_23125_130830"
          />
          <feOffset dy="-2" />
          <feGaussianBlur stdDeviation="13.95" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.591573 0 0 0 0 0.914663 0 0 0 0 0.822352 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_23125_130830"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_23125_130830"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="-8" />
          <feGaussianBlur stdDeviation="3.2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.541176 0 0 0 0 0.878431 0 0 0 0 0.811765 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_23125_130830"
          />
        </filter>
        <filter
          id="filter2_i_23125_130830"
          x="150.538"
          y="57.7756"
          width="28.4493"
          height="31.4495"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3.8" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.541176 0 0 0 0 0.878431 0 0 0 0 0.811765 0 0 0 0.93 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_23125_130830"
          />
        </filter>
        <filter
          id="filter3_d_23125_130830"
          x="31.2"
          y="7.7"
          width="89.9375"
          height="70.5622"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feGaussianBlur stdDeviation="5.65" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.933333 0 0 0 0 0.588235 0 0 0 0.55 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_23125_130830"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_23125_130830"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_23125_130830"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(161.493 119.453) rotate(-178.774) scale(138.025 203.747)"
        >
          <stop offset="0.12085" stopColor="#70EACD" />
          <stop offset="0.373685" stopColor="#B1FFED" />
          <stop offset="0.720516" stopColor="#FFEAAF" stopOpacity="0.72" />
          <stop offset="1" stopColor="#FFEFC4" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_23125_130830">
          <rect width="252" height="138" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
